import { render, staticRenderFns } from "./SubmissionPreview.vue?vue&type=template&id=10e52a68&scoped=true&"
import script from "./SubmissionPreview.vue?vue&type=script&lang=js&"
export * from "./SubmissionPreview.vue?vue&type=script&lang=js&"
import style0 from "./SubmissionPreview.vue?vue&type=style&index=0&id=10e52a68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10e52a68",
  null
  
)

export default component.exports